/**
 * Mime types for media assets
 * @module services/media-assets/mime-types
 */

/**
 * The mime type use when serving vtt files
 */
export const MEDIA_ASSETS_MIME_TYPE_VTT = 'text/vtt'

/**
 * The mime type use when serving hls files
 */
export const MEDIA_ASSETS_MIME_TYPE_HLS = 'application/x-mpegurl'
